import { useSeenThingsPresenter } from '@Components/Modals/SeenThings/SeenThingsPresenter';
import useAuthPresenter from '@Screens/Main/authPresenter';
import useSideNavPresenter from '@Screens/Main/sideNavPresenter';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components/native';

import OwnableTheme from '../../../../../assets/OwnableTheme';
import { Text } from '../../../../Common/Text';
import useSmartBrowserPresenter from './SmartBrowser.presenter';

import { useAuthStore } from '~stores/authentication';

const StyledNavigationAccordionWrapper = styled.View<{
  height?: number;
  accordionWidth?: number | string;
  grow?: boolean;
  thin?: boolean;
}>`
  display: flex;
  width: 100%;
  padding: 30px;
  align-items: center;
  position: relative;
  overflow: hidden;
  background-color: white;
  pointer-events: all;
`;

const StyledHorizontalSeparator = styled.View`
  width: 100%;
  height: 2px;
  background-color: ${OwnableTheme.colors.lightGray};
  margin-bottom: 18px;
`;

const StyledMenuContainer = styled.View`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledTouchableMenuItem = styled.TouchableOpacity`
  display: flex;
  width: 100%;
  margin-bottom: 18px;
  padding-left: 26px;
  padding-right: 26px;
`;

const StyledMenuItem = styled.View`
  display: flex;
  width: 100%;
  margin-bottom: 18px;
  padding-left: 26px;
  padding-right: 26px;
`;

const StyleSignInButton = styled.TouchableOpacity`
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: ${OwnableTheme.colors.black};
  border-radius: 15px;
  padding: 16px 26px;
  margin-bottom: 28px;
`;

type Props = {
  onHeight?: (height: number) => void;
};

const SmartBrowser: FC<Props> = ({ onHeight }) => {
  const { handleSwitchPress } = useSmartBrowserPresenter();
  const { handleAboutClick, toggleSupport, handleUserAccountClick } =
    useSideNavPresenter();
  const { handleLogOutClickAsync } = useAuthPresenter();
  const { currentUser } = useAuthStore();
  const { show } = useSeenThingsPresenter();

  const handleLoginOrLogout = () => {
    if (currentUser) {
      handleLogOutClickAsync().then();
    } else {
      handleSwitchPress(true).then();
    }
  };

  return (
    <StyledNavigationAccordionWrapper
      onLayout={(event: any) => onHeight?.(event.nativeEvent.layout.height)}
    >
      <StyleSignInButton onPress={handleLoginOrLogout}>
        <Text
          color={OwnableTheme.colors.white}
          weight='regular'
          align='left'
          size='xs'
        >
          {currentUser ? 'Sign out' : 'Sign in'}
        </Text>
      </StyleSignInButton>

      {currentUser && (
        <StyledMenuContainer>
          <StyledMenuItem>
            <Text
              color={OwnableTheme.colors.black}
              weight='regular'
              size='s'
              align='left'
            >
              {currentUser?.email}
            </Text>
          </StyledMenuItem>

          <StyledTouchableMenuItem onPress={handleUserAccountClick}>
            <Text
              color={OwnableTheme.colors.black}
              weight='regular'
              size='s'
              align='left'
            >
              My details
            </Text>
          </StyledTouchableMenuItem>

          <StyledHorizontalSeparator />
        </StyledMenuContainer>
      )}

      {/* Commented out if needed in future */}
      {/* <StyledTouchableMenuItem onPress={() => handleQuickTipsPress()}>
        <Text
          color={OwnableTheme.colors.black}
          weight='regular'
          size='s'
          align='left'
        >
          Quick tips
        </Text>
      </StyledTouchableMenuItem> */}

      <StyledTouchableMenuItem onPress={show}>
        <Text
          color={OwnableTheme.colors.black}
          weight='regular'
          size='s'
          align='left'
        >
          Things I have seen
        </Text>
      </StyledTouchableMenuItem>

      <StyledTouchableMenuItem onPress={handleAboutClick}>
        <Text
          color={OwnableTheme.colors.black}
          weight='regular'
          size='s'
          align='left'
        >
          About Toscan
        </Text>
      </StyledTouchableMenuItem>

      <StyledTouchableMenuItem onPress={toggleSupport}>
        <Text
          color={OwnableTheme.colors.black}
          weight='regular'
          size='s'
          align='left'
        >
          Support
        </Text>
      </StyledTouchableMenuItem>
    </StyledNavigationAccordionWrapper>
  );
};

export default observer(SmartBrowser);
